import { forwardRef, type InputHTMLAttributes } from 'react';
import { Search } from 'lucide-react';

export interface SearchInputProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'type'
> {
  className?: string;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className = '', placeholder = 'Search...', ...props }, ref) => {
    return (
      <div
        className={[
          'flex items-center gap-2 rounded-lg border border-border bg-background px-3 py-2',
          'focus-within:border-border-focus focus-within:ring-1 focus-within:ring-border-focus',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <Search
          size={16}
          className="text-muted-foreground shrink-0"
        />
        <input
          ref={ref}
          type="search"
          placeholder={placeholder}
          // `type="search"` keeps the semantics (and the mobile keyboard's
          // Search key), but WebKit and Blink decorate it with a native
          // round ✕ that the design system never draws — QA reported it as
          // an element the app renders and Figma does not (YAR-161).
          className="flex-1 bg-transparent text-sm text-foreground placeholder:text-text-placeholder outline-none border-none p-0 [&::-webkit-search-cancel-button]:appearance-none [&::-webkit-search-decoration]:appearance-none"
          {...props}
        />
      </div>
    );
  },
);
SearchInput.displayName = 'SearchInput';
